import { initializeApp } from 'firebase/app'
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  GoogleAuthProvider,
  signInWithPopup,
  onAuthStateChanged as _onAuthStateChanged,
  User
} from 'firebase/auth'

const firebaseConfig = {
  apiKey: (import.meta as any).env?.VITE_GOOGLE_API_KEY,
  authDomain: (import.meta as any).env?.VITE_GOOGLE_AUTHDOMAIN,
  projectId: (import.meta as any).env?.VITE_GOOGLE_PROJECTID,
  storageBucket: (import.meta as any).env?.VITE_GOOGLE_STORAGE_BUCKET,
  messagingSenderId: (import.meta as any).env?.VITE_GOOGLE_MESSAGING_SENDER_ID || (import.meta as any).env?.VITE_GOOGLE_MESSAGEING_SENDERID,
  appId: (import.meta as any).env?.VITE_GOOGLE_APPID,
  measurementId: (import.meta as any).env?.VITE_GOOGLE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
setPersistence(auth, browserLocalPersistence)
const provider = new GoogleAuthProvider()

export const signInWithGoogle = () => signInWithPopup(auth, provider)
export const signOut = () => auth.signOut()
export const onAuthStateChanged = (cb: (u: User | null) => void) => _onAuthStateChanged(auth, cb)
export const getAuthInstance = () => auth